/** User secret. */
export class UserSecret {
  constructor(data) {
    this.userSecret = data.userSecret;
  }
}
